export const GET_FRAME_ICONS = "GET_FRAME_ICONS";
export const GET_FRAME_SHAPES = "GET_FRAME_SHAPES";
export const GET_FRAME_COLORS = "GET_FRAME_COLORS";
